import { render, staticRenderFns } from "./item-info-other-lenses.vue?vue&type=template&id=6f23a246&scoped=true"
import script from "./item-info-other-lenses.vue?vue&type=script&lang=js"
export * from "./item-info-other-lenses.vue?vue&type=script&lang=js"
import style0 from "./item-info-other-lenses.vue?vue&type=style&index=0&id=6f23a246&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23a246",
  null
  
)

export default component.exports